import Vue from 'vue'
import axios from 'axios'
import localforage from 'localforage'
import defaulter from '@/modules/defaulter'

export default {
  state: {
    initializationStarted:  false,
    initializationComplete: false,
    initializationFailed: false,
    baseURL: (window.location.hostname==='localhost'?'http://localhost:8888':'https://banksecurity101.net') + '/api/',
    api: null,
    sessionId: null,
    defaultSessionStatus: {
      isInSession:         false,
      sessionId:           '',
      isAccountAuthorized: false,
      isLoggedIn:          false,
      isOtpConfigured:     false,
      isOtpVerified:       false,
      otpMessage:          ''
    },
    sessionStatus: {
      isInSession:         false,
      sessionId:           '',
      isAccountAuthorized: false,
      isLoggedIn:          false,
      isOtpConfigured:     false,
      isOtpVerified:       false,
      otpMessage:          ''
    },
    otpQrCodeUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsCAQAAADTdEb+AAACHElEQVR42u3SMQ0AAAzDsJU/6aGo+tgQouSgIBJgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2OBsTAWxgJjYSyMBcbCWBgLjIWxMBYYC2NhLDAWxsJYYCyMhbHAWBgLY4GxMBbGAmNhLIwFxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC2OBsTAWxgJjYSyMBcbCWBgLjIWxMBYYC2NhLDAWxsJYYCyMhbHAWBgLY4GxMBbGAmNhLIwFxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2OBsTAWxgJjYSyMBcbCWBgLjIWxMBbGAmNhLIwFxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2OBsTAWxgJjYSyMBcbCWBgLjIWxMBYYC2NhLDAWxsJYYCyMhbHAWBgLY4GxMBbGAmNhLIwFxsJYGAuMhbEwFhgLY2EsjCUBxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWGAsjIWxwFjsPeVaAS0/Qs6MAAAAAElFTkSuQmCC',
    sessionUser: null,
  },
  getters: {
    initializationStarted:  state => state.initializationStarted,
    initializationComplete: state => state.initializationComplete,
    initializationFailed:   state => state.initializationFailed,
    api: state => state.api,
    sessionStatus: state => state.sessionStatus,
    sessionUser: state => state.sessionUser,
    accountAuthorized: state => state.sessionStatus.isAccountAuthorized,
    loggedIn: state => state.sessionStatus.isLoggedIn,
    otpConfigured: state => state.sessionStatus.isOtpConfigured,
    otpVerified: state => state.sessionStatus.isOtpVerified,
    isPwResetRequired: state => {
      return (state.sessionUser) ? state.sessionUser.pw_reset : null
    },

    otpQrCodeUrl: state => state.otpQrCodeUrl,
    otpMessage: state => state.sessionStatus.otpMessage,
    sessionUserIsFullyLoggedIn: state => {
      return (state.sessionUser && state.sessionStatus.isOtpVerified) ? true : false
    },
    sessionUserIsAdmin: state => {
      return (state.sessionUser && state.sessionUser.role==='admin') ? true : false
    },
    sessionUserIsBank: state => {
      return (state.sessionUser && state.sessionUser.role==='bank') ? true : false
    },
    sessionUserIsBankOrAdmin: state => {
      return (state.sessionUser && (state.sessionUser.role==='bank' || state.sessionUser.role==='admin')) ? true : false
    },
    sessionUserHomePage: (state, getters) => {
      if (state.sessionUser) {
        if (getters.isPwResetRequired) return '/my-profile'
        if (getters.sessionUserIsAdmin) return '/admin'
        if (getters.sessionUserIsBankOrAdmin) return '/dashboard'
        if (getters.sessionUserIsFullyLoggedIn) return '/risk-assessment'
        return '/'
      }
      return '/login'
    }
  },
  mutations: {
    sessionId (state, newId: string) {
      if (newId) {
        state.sessionId = newId
        state.api = axios.create({
          baseURL: state.baseURL,
          // headers: {'Authorization': 'PHPSESSID ' + newId},
          headers: {'Authorization': 'Token ' + newId},
          validateStatus: null // always resolve
        })
        // sessionStorage.setItem('PHPSESSID', newId)
        localforage.setItem('sessionId', newId);
      } else {
        state.sessionId = null
        state.api = axios.create({
          baseURL: state.baseURL,
          validateStatus: null // always resolve
        })
        // sessionStorage.removeItem('PHPSESSID')
        localforage.removeItem('sessionId')
      }
    },
    sessionStatus (state, newStatus: SessionStatus) {
      console.log('store.session.commit.sessionStatus', newStatus)
      if (newStatus) {
        for (let key in state.sessionStatus) {
          Vue.set(state.sessionStatus, key, newStatus[key])
        }
      }
    },
    sessionUser (state, newUser: User) {
      state.sessionUser = newUser
    },
    resetSession (state) {
      state.sessionStatus = defaulter.copy(state.defaultSessionStatus)
      state.sessionUser = null
      state.sessionId = null
      state.api = axios.create({
        baseURL: state.baseURL,
        validateStatus: null // always resolve
      })
      localforage.removeItem('sessionId')
    }
  },
  actions: {

    async initialize ({state, commit, dispatch}) {
      console.log('session.initialize')
      state.initializationStarted = true
      let sessionCheckResult = null
      const sessionId = await localforage.getItem('sessionId')
      console.log('  sessionId', sessionId)
      commit('sessionId', sessionId)
      if (sessionId) {
        try {
          sessionCheckResult = await dispatch('checkCurrentSession')
        } catch (error) {
          state.initializationFailed = true
          return {
            success: false,
            message: "Could not connect to server."
          }
        }
        console.log('sessionCheckResult', sessionCheckResult)
      }
      if (!sessionCheckResult || sessionCheckResult.success === false) {
        commit('resetSession')
        // state.initializationFailed = true
      }
      state.initializationComplete = true
      return sessionCheckResult
    },

    async login ({state, commit, dispatch}, form: LoginForm) {
      console.log('session.login')
      let response
      try {
        response = await state.api.post('auth/login', form)
      } catch (error) {
        return {
          success: false,
          message: "Could not connect to server."
        }
      }
      if (response.status === 200) {
        if (response.data) {
          console.log('  session.login response', response.data)
          if (response.data.success) {
            console.log('    committing status')
            commit('sessionStatus', response.data)
            commit('sessionId',     response.data.sessionId)
            if (response.data.hasOwnProperty('user'))     commit('sessionUser',     response.data.user)
            if (response.data.hasOwnProperty('bank'))     commit('currentBank',     response.data.bank)
            if (response.data.hasOwnProperty('customer')) commit('currentCustomer', response.data.customer)
            if (response.data.isLoggedIn && !response.data.isOtpConfigured) {
              await dispatch('getOtpQrCodeUrl')
            }
            return {
              success: true,
              message: "You are now logged in."
            }
          }
          return {
            success: false,
            message: response.data.message
          }
        }
        return {
          success: false,
          message: "Unexpected login failure."
        }
      }
      else {
        return {
          success: false,
          message: response.data
        }
      }
    },

    async getOtpQrCodeUrl ({state, commit}) {
      let response
      if (state.sessionId) {
        try {
          response = await state.api.get('auth/otp-generate')
        } catch (error) {
          return {
            success: false,
            message: "Could not connect to server."
          }
        }
        console.log('  getOtpQrCodeUrl response', response)
        if (response.status === 200) {
          if (response.data.success === true) {
            state.otpQrCodeUrl = response.data.url
          } else {
            state.otpQrCodeUrl = ''
            console.log('  set OTP message to', response.data.message)
            Vue.set(state.sessionStatus, 'otpMessage', response.data.message)
          }
        }
      }
    },

    async otpVerify ({state, commit}, form: OtpForm) {
      const response = await state.api.post('auth/otp-verify', form)
      if (response.status === 200) {
        if (response.data.success) {
          commit('sessionStatus', response.data)
          if (response.data.hasOwnProperty('user'))     commit('sessionUser', response.data.user)
          if (response.data.hasOwnProperty('bank'))     commit('currentBank', response.data.bank)
          if (response.data.hasOwnProperty('customer')) commit('currentCustomer', response.data.customer)
        }
        return {
          success: response.data.success,
          message: response.data.message
        }
      }
      else {
        return {
          success: false,
          message: response.data.message
        }
      }
    },

    async checkCurrentSession ({state, commit, dispatch}) {
      let response
      if (!state.sessionId) {
        return {
          success: null,
          message: "No current login session."
        }
      }
      try {
        response = await state.api.get('auth/current')
      } catch (error) {
        return {
          success: false,
          message: "Could not connect to server."
        }
      }
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not get current session status."
        }
      }
      if (response.data.success) {
        commit('sessionStatus', response.data)
        if (response.data.hasOwnProperty('user'))     commit('sessionUser', response.data.user)
        if (response.data.hasOwnProperty('bank'))     commit('currentBank', response.data.bank)
        if (response.data.hasOwnProperty('customer')) commit('currentCustomer', response.data.customer)

        // Get OTP QR Code if OTP is not yet configured.
        if (response.data.isLoggedIn && !response.data.isOtpConfigured) {
          dispatch('getOtpQrCodeUrl')
        }
      }
      return response.data
    },

    async logout ({state, commit}) {
      let sessionUser = null
      const response = await state.api.post('auth/logout')
      commit('resetSession')
      return {
        success: true,
        message: "You are now logged out."
      }
    },

    async updateProfile ({state, commit}, user: User) {
      const response = await state.api.patch('user', user)
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not update user profile."
        }
      }
      if (response.data.success && response.data.user) {
        commit('sessionUser', response.data.user)
      }
      return response.data
    },

    // Debug

    logState ({state}) {
      console.log('store.session', state)
    }

  }
}
